import { ProtocolVersion, DecryptedPayload, FillItemContentSpecialized, PayloadTimestampDefaults, } from '@standardnotes/models';
import { UuidGenerator } from '@standardnotes/utils';
import { SNRootKey } from './RootKey';
import { ContentType } from '@standardnotes/domain-core';
export function CreateNewRootKey(content) {
    const uuid = UuidGenerator.GenerateUuid();
    const payload = new DecryptedPayload({
        uuid: uuid,
        content_type: ContentType.TYPES.RootKey,
        content: FillRootKeyContent(content),
        ...PayloadTimestampDefaults(),
    });
    return new SNRootKey(payload);
}
export function FillRootKeyContent(content) {
    if (!content.version) {
        if (content.dataAuthenticationKey) {
            /**
             * If there's no version stored, it must be either 001 or 002.
             * If there's a dataAuthenticationKey, it has to be 002. Otherwise it's 001.
             */
            content.version = ProtocolVersion.V002;
        }
        else {
            content.version = ProtocolVersion.V001;
        }
    }
    return FillItemContentSpecialized(content);
}
